import React from "react";
import {CustomOrderModalState} from "../interface/CustomOrderModalState";
import Toast from "../../../../utility/toast";
import AppCartController from "../../../Main/controller/AppCartController";
import i18n from "../../../../i18n";

export default class CustomOrderModalController {
    protected state: CustomOrderModalState;
    protected setState: React.Dispatch<React.SetStateAction<CustomOrderModalState>>;

    constructor(state: CustomOrderModalState, setState: React.Dispatch<React.SetStateAction<CustomOrderModalState>>) {
        this.state = state;
        this.setState = setState;
    }

    onChanePriceSeparator(e: React.ChangeEvent<HTMLInputElement>) {
        const rawValue = e.target.value.replace(/[^0-9]/g, "");
        const formattedValue = rawValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        this.setState({
            ...this.state,
            separatorPrice: formattedValue,
            price: Number(rawValue),
        });
    }

    submit(e: any) {
        e.preventDefault();
        if (!this.state.price)
            return Toast.error(i18n.t("toast.priceRequired"))

        if (AppCartController.addCustomOrder(this.state.price)) {
            Toast.success(i18n.t("toast.customBuyAddSuccess"))
            return window.dispatchEvent(new Event('closeModal'))
        }

        Toast.error(i18n.t("toast.saveCustomBuyFailed"))
    }
}